<!-- identical to home landing, kept anchors for vertical menu -->
<svg xmlns="http://www.w3.org/2000/svg" class="d-none">
  <symbol id="check2" viewBox="0 0 16 16"><path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/></symbol>
</svg>

<div id="ppk-downloader-section" class="container col-xxl-8 px-4" style="scroll-margin-top: 96px;">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-3">
    <div class="col-10 col-sm-8 col-lg-6">
      <br>
      <img src="assets/images/landing/GeoAstra_PPK_Downloader_diagram.drawio.png" class="d-block mx-lg-auto img-fluid" alt="GeoAstra PPK Downloader Diagram" width="700" height="500" loading="lazy">
    </div>
    <div class="col-lg-6">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">GeoAstra PPK Downloader</h1>
      <h2 class="display-5 lh-1 mb-3">Download RTK Base correction data (RTCM) for use in PPK processing</h2>
      <ul>
        <li>Simplify Your PPK Workflow</li>
        <li>Acquire RTK Base Station data directly from any NTRIP CORS mountpoint</li>
        <li>Streamline the PPK process – focus on Rover data collection while our PPK Downloader handles the Base station side for you</li>
        <li>Cut costs by 50% or more – with CORS access, you no longer need to own a Base station for PPK</li>
        <li>Schedule downloads in advance for maximum convenience</li>
        <li>Easy to use – cm-level accuracy data logging is now as simple as using a standalone GNSS logger, without the hassle of running a Base station</li>
        <li>Collect high-precision data anywhere – achieve cm-level accuracy without needing radios or internet connections in the field</li>
      </ul>
      <div class="d-grid gap-2 d-md-flex justify-content-md-start">
        <button type="button" class="btn btn-outline-secondary btn-lg px-4" (click)="login()">Login</button>
        <button type="button" class="btn btn-primary btn-lg px-4 me-md-2" (click)="signup()">Sign-up</button>
      </div>
    </div>
  </div>
</div>

<div id="quick-start-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 96px;">
  <!-- 1th paragraph -->
  <div class="row flex-lg-row-reverse align-items-center g-5 py-5">

    <div class="col-lg-6 ppk-body">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Quick Start / User Guide</h1>
      <br>
      <h2 class="display-5 lh-1 mb-3">Introducing GeoAstra NTRIP Service</h2>
      <p >Is your current NTRIP service provider too expensive? Is their NTRIP mount point too far away from you? Do you find it difficult or inconvenient to connect your RTK rover to your own base? Owning an RTK base and connecting it with our GeoAstra NTRIP Caster is the solution to all these problems.
      </p>
      <p>GeoAstra NTRIP Caster functions as a NTRIP hub on the internet, connecting your RTK base(s) and rovers. 
      </p>
      <p>When you connect your RTK base(s) to our GeoAstra NTRIP Caster, your RTK base transforms into an Internet Base NTRIP Service. This means your RTK rovers, including survey GNSSs, robots, drones, agricultural equipment, and GNSS receivers, can now receive RTK correction data effortlessly. 
      </p>
      <p>GeoAstra NTRIP Caster is incredibly user-friendly. With just a few clicks, you can sign up and obtain your free NTRIP caster mount points, and start using them in under 20 seconds. Apply cm-level accuracy to your projects today! Experience the easy, convenient, and affordable internet-based RTK technology with GeoAstra. 
      </p>
    </div>
    <div class="col-10 col-sm-8 col-lg-6">
      <br>
      <img src="assets/images/landing/GeoAstra_ntrip_caster_rtk-via-internet.png" class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="700" height="500" loading="lazy">
    </div>
  </div>
 <!-- 2nd paragraph -->
  <div class="row flex-lg-row-reverse align-items-center g-5 py-5">

    <div class="col-lg-6 ppk-body">
     
      <h2 class="display-5 lh-1 mb-3">Sign-up / Login</h2>
      <p >The GeoAstra NTRIP Caster login screen allows you to sign-up / login using your existing Apple, Google, or Microsoft account. This means no need for a new account or entering personal information.  
      </p>
      <p >Using social sign-in is convenient and safe. It offers quick access without filling out forms and reduces the number of passwords to remember. Additionally, your personal information remains with the social platform, ensuring your data stays secure.  
      </p>
      <p >Alternatively, you can create a new user ID and password directly on our website. Just make sure to enter a valid email address; our system will email you a verification link, and your account will only be activated once your email address has been verified.  
      </p>
      <p >Enjoy a seamless, secure, and efficient sign-up / login experience with GeoAstra NTRIP Caster by simply selecting your preferred sign-in option.  
      </p>
    </div>
    <div class="col-10 col-sm-8 col-lg-6">
      <br>
      <img src="assets/images/landing/signin_screen_no_bg.png" class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="700" height="500" loading="lazy">
    </div>
  </div>
  <!-- 3rd paragraph -->
    <div class="row flex-lg-row-reverse align-items-center g-5 py-5">

      <div class="col-lg-6 ppk-body">
        <h2 class="display-5 lh-1 mb-3">After You Login</h2>
        <p>Upon your first login, a fully functional NTRIP caster mount point is automatically created for you. Our system will generate the mount point name, along with the usernames and passwords for both your RTK base and rover. Each free user account includes 1 mount point, supporting 1 RTK base connection and up to 2 rover connections. If you need additional capacity, consider upgrading your account.
        </p>
        <p>The passwords here are displayed as plain text rather than being replaced by asterisks (*). This is intentional, as users need to see the actual password to enter it into their RTK device.
        </p>
        <p>There are 3 menu items: Dashboard, My Profile, and My Mountpoint.
        </p>
        <p><strong>Dashboard:</strong> Displays all the information you need to connect to your NTRIP caster mount point. Settings for the RTK base are on the left side, and settings for the RTK rover are on the right side.
        </p>
        <p><strong>My Profile:</strong> Shows user account information. You can select your own usernames and passwords for the RTK base and rover. Press the "Update" button to save changes. Note that usernames need to be unique within our NTRIP caster. If your chosen username is already taken, you'll be prompted to choose another. 
        </p>
        <p><strong>My Mountpoint:</strong> Displays all mount point-related parameters. You can leave these settings as they are, as they don't affect your NTRIP caster’s operation. Only update the mount point fields if your rover needs specific information from the source table. Remember, the mount point name must be unique within the entire NTRIP caster. The latitude and longitude values are captured based on your GeoIP when the mount point is created, but you can update these values.

        </p>
      </div>
      <div class="col-10 col-sm-8 col-lg-6">
        <br>
        <img src="assets/images/landing/dashboard_screen.png" class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="700" height="500" loading="lazy">
      </div>
    </div>
    <!-- 4th paragraph -->
    <div class="row flex-lg-row-reverse align-items-center g-5 py-5">

      <div class="col-lg-6 ppk-body">
        <h2 class="display-5 lh-1 mb-3">Configure your RTK Bases and Rovers</h2>
        <p>All the settings required for connecting your RTK base and rover can be found on the Dashboard page mentioned above. Please note that the mount point, username, and password are case sensitive, so enter them carefully. </p>
        <p>Most RTK bases on the market use NTRIP V1 and do not require a username. However, if your RTK base uses NTRIP V2, a username is necessary. </p>
      </div>
      <div class="col-10 col-sm-8 col-lg-6">
        <br>
        <img src="assets/images/landing/RTK_Base_and_Rover_Settings.png" class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="700" height="500" loading="lazy">
      </div>
    </div>

  <!-- end update -->

</div>

<div id="pricing-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 96px;">
  <div class="container py-3">    
    <main>
      <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
        <br>
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3 text-body-emphasis">Pricing</h1>      
      </div>
      <div class="row row-cols-1 row-cols-md-3 mb-3 text-center align-items-stretch">          
        <div class="col d-flex">
          <div class="card mb-4 rounded-3 shadow-sm h-100 d-flex flex-column">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Free</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$0<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>1 base stations/mount points</li>
                <li>2 rovers</li>
                <li>Source Table</li>
                <li>NTRIP Live Monitor</li>
                <li>Shared Server</li>
                <li>Forum Support</li>
                
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-outline-primary" (click)="login()">Sign up</button>
            </div>
          </div>
        </div>
        <div class="col d-flex">
          <div class="card mb-4 rounded-3 shadow-sm h-100 d-flex flex-column">
            <div class="card-header py-3">
              <h4 class="my-0 fw-normal">Pro</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$99<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>10 base stations/mount points</li>
                <li>100 rovers</li>
                <li>Source Table</li>
                <li>NTRIP Live Monitor</li>
                <li>Shared Server</li>
                <li>Forum Support</li>
                <li>Email Support</li>
                <li>RTK Base Analyzer</li>
                <li>PPK Downloader</li>
                
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-primary" (click)="redirectToPro()">Order Now</button>
            </div>
          </div>
        </div>
        <div class="col d-flex">
          <div class="card mb-4 rounded-3 shadow-sm border-primary h-100 d-flex flex-column">
            <div class="card-header py-3 text-bg-primary border-primary">
              <h4 class="my-0 fw-normal">Enterprise</h4>
            </div>
            <div class="card-body d-flex flex-column flex-grow-1">
              <h1 class="card-title pricing-card-title">$399<small class="text-body-secondary fw-light">/mo</small></h1>
              <ul class="list-unstyled mt-3 mb-4">
                <li>50 base stations /mount points</li>
                <li>1,000 rovers</li>
                <li>Source Table</li>
                <li>NTRIP Live Monitor</li>
                <li>Dedicate Server</li>
                <li>Forum Support</li>
                <li>Email Support</li>
                <li>RTK Base Analyzer</li>
                <li>PPK Downloader</li>
                <li>Custom Domain</li>
                <li>APIs</li>
                <li>Web Management console</li>
                
              </ul>
              <button type="button" class="mt-auto w-100 btn btn-lg btn-primary" (click)="redirectToEnterPrise()">Order Now</button>
            </div>
          </div>
        </div>
      </div>
  
      <h2 class="display-6 text-center mb-4">Compare Plans</h2>
  
      <div class="table-responsive">
        <table class="table text-center">
          <thead>
            <tr>
              <th style="width: 34%;"></th>
              <th style="width: 22%;">Free</th>
              <th style="width: 22%;">Pro</th>
              <th style="width: 22%;">Enterprise</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row" class="text-start">Base Stations / Mount Points</th>
              <td>1</td>
              <td>10</td>
              <td>50</td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Rovers</th>
              <td>2</td>
              <td>100</td>
              <td>1000</td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Ntrip Source Table</th>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Share Server</th>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Forum Support</th>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Email Support</th>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>

            <!-- Newly added feature rows -->
            <tr>
              <th scope="row" class="text-start">Live Ntrip connections monitor</th>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">RTK Base Analyzer</th>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">PPK Downloader</th>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>

            <tr>
              <th scope="row" class="text-start">Custom Domain</th>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">APIs</th>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Connection Log</th>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Web Management Console</th>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <!-- Moved: Dedicate Server row now below Email Support -->
            <tr>
              <th scope="row" class="text-start">Dedicate Server</th>
              <td></td>
              <td></td>
              <td><svg class="bi" width="24" height="24"><use xlink:href="#check"/></svg></td>
            </tr>
            <tr>
              <th scope="row" class="text-start">Minimum Subscription Requirement</th>
              <td>None</td>
              <td>1 month</td>
              <td>12 months</td>
            </tr>

          </tbody>
        </table>
      </div>
    </main>
    <br>
    <p >We offer software customization and integration services. Please email <a href="mailto:info@geoastra.com">info&#64;geoastra.com</a> to discuss your needs.</p>
  

  </div>
  
</div>

<div id="stores-section" class="container col-xxl-8 px-4 py-5" style="scroll-margin-top: 96px;">
  <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
    <div class="col-10 col-sm-8 col-lg-6">
      <br>
      <img src="assets/images/landing/stores.png" class="d-block mx-lg-auto img-fluid" alt="Stores" width="700" height="500" loading="lazy">
    </div>
    <div class="col-lg-6 ppk-body">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">RTK GNSS Stores</h1>
      <p>Are you looking to buy RTK devices?</p>
      <div class="store-buttons mt-3">
        <a class="store-cta me-2" href="https://canadagps.ca/" target="_blank" rel="noopener" aria-label="Open Canada Store">
          <img src="assets/images/landing/Canada-SVG.svg" alt="Canada" class="ca-flag-img" />
          <span class="store-label">STORE</span>
        </a>
        <a class="store-cta" href="https://gpswebshop.com/" target="_blank" rel="noopener" aria-label="Open Global Store">
          <span class="material-icons icon icon-earth" aria-hidden="true" style="color:#3b82f6;">language</span>
          <span class="store-label">STORE</span>
        </a>
      </div>
    </div>
  </div>
</div>
